import jsCookie from 'js-cookie';
import { v4 as uuid } from 'uuid';
import {
  ACCESS_TOKEN_EXPIRATION,
  BASKET_TOKEN_NAME,
  SENDER_ID_EXPIRATION,
} from './constants';

export function createClientCookiesManager() {
  return {
    get basketToken() {
      const cookie = jsCookie.get(BASKET_TOKEN_NAME);

      if (!cookie) {
        return this.setBasketToken();
      } else {
        return cookie;
      }
    },

    setBasketToken() {
      const token = uuid();

      const expires = new Date();
      expires.setSeconds(ACCESS_TOKEN_EXPIRATION);

      jsCookie.set(BASKET_TOKEN_NAME, token, { expires });

      return token;
    },

    get senderId() {
      return jsCookie.get('sender_id');
    },

    setSenderId(sender_id: string, expiresIn = SENDER_ID_EXPIRATION) {
      const expires = new Date();
      expires.setSeconds(expiresIn);

      jsCookie.set('sender_id', sender_id, {
        expires,
      });
    },

    setOrderTotalPrice(price: number) {
      jsCookie.set('orderTotalPrice', price.toString());
    },

    removeOrderTotalPrice() {
      jsCookie.remove('orderTotalPrice');
    },

    get companyName() {
      return jsCookie.get('companyName');
    },

    setCompanyName(company: string) {
      jsCookie.set('companyName', company);
    },

    removeCompanyName() {
      jsCookie.remove('companyName');
    },
  };
}
